import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10",
      cy: "10.5",
      r: "7.125",
      stroke: "#031f30",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#031f30",
      d: "M13.75 9.875h-3.125V6.75a.625.625 0 0 0-1.25 0v3.125H6.25a.625.625 0 1 0 0 1.25h3.125v3.125a.625.625 0 1 0 1.25 0v-3.125h3.125a.624.624 0 1 0 0-1.25"
    }, null, -1)
  ]))]))
}
export default { render: render }